export default __webpack_public_path__ + "static/media/notification.9e44844f.svg";